import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=29054bb8&scoped=true&"
import script from "./Self.vue?vue&type=script&lang=js&"
export * from "./Self.vue?vue&type=script&lang=js&"
import style0 from "./Self.vue?vue&type=style&index=0&id=29054bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29054bb8",
  null
  
)

export default component.exports